import {z as r} from 'zod';

export const deletedReviewsCountSchema = r.object({
    value: r.number(),
    comparedValue: r.number().nullable(),
    delta: r.number().nullable(),
});

export type DeletedReviewsCountType = r.infer<typeof deletedReviewsCountSchema>;
